'use client';

import * as SwitchPrimitives from '@radix-ui/react-switch';

import * as React from 'react';

import { cn } from '@/utils/styles';

type SwitchSize = 'default' | 'sm' | 'xs';

interface SwitchProps extends React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> {
	size?: SwitchSize;
}

const rootSizeClasses: Record<SwitchSize, string> = {
	default: 'h-6 w-11',
	sm: 'h-5 w-9',
	xs: 'h-4 w-7',
};

const thumbSizeClasses: Record<SwitchSize, string> = {
	default: 'h-5 w-5 data-[state=checked]:translate-x-5',
	sm: 'h-4 w-4 data-[state=checked]:translate-x-4',
	xs: 'h-3 w-3 data-[state=checked]:translate-x-3',
};

const Switch = React.forwardRef<React.ElementRef<typeof SwitchPrimitives.Root>, SwitchProps>(
	({ className, size = 'default', ...props }, ref) => (
		<SwitchPrimitives.Root
			className={cn(
				'peer inline-flex shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-40 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input',
				rootSizeClasses[size],
				className
			)}
			{...props}
			ref={ref}
		>
			<SwitchPrimitives.Thumb
				className={cn(
					'pointer-events-none block rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=unchecked]:translate-x-0',
					thumbSizeClasses[size]
				)}
			/>
		</SwitchPrimitives.Root>
	)
);
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
